<script lang="ts">
  import { onMount } from 'svelte';
  import { fetchBillingStatus } from '../lib/billing';

  let verificando = $state(true);
  let activo = $state(false);
  let rechazado = $state(false);
  let intentos = $state(0);

  onMount(() => {
    const poll = setInterval(async () => {
      intentos++;
      const s = await fetchBillingStatus();
      if (s?.estado === 'active') {
        activo = true;
        verificando = false;
        clearInterval(poll);
      } else if (intentos >= 10 && s?.estado === 'trial') {
        rechazado = true;
        verificando = false;
        clearInterval(poll);
      } else if (intentos >= 20) {
        verificando = false;
        clearInterval(poll);
      }
    }, 3000);
    return () => clearInterval(poll);
  });
</script>

<div class="page">
  {#if activo}
    <main class="card success">
      <h1>Pago recibido</h1>
      <p>Su suscripcion esta activa. Acceso completo a Toscana.</p>
      <a class="btn" href="/">Ir al sistema</a>
    </main>
  {:else if rechazado}
    <main class="card rejected">
      <h1>Pago rechazado</h1>
      <p>No se detecto el pago. Intente de nuevo o use otra tarjeta.</p>
      <a class="btn retry" href="/billing/trial-expired">Reintentar pago</a>
    </main>
  {:else if verificando}
    <main class="card ok">
      <h1>Verificando pago...</h1>
      <p>Confirmando transaccion con Recurrente.</p>
      <div class="spinner"></div>
    </main>
  {:else}
    <main class="card ok">
      <h1>Pago en proceso</h1>
      <p>Si ya pago en Recurrente, su cuenta se activa en unos segundos.</p>
      <a class="btn" href="/">Ir al sistema</a>
    </main>
  {/if}
</div>

<style>
  .page { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 2rem; background: #f8fafc; }
  .card { max-width: 420px; background: #fff; border-radius: 14px; padding: 2rem; text-align: center; border: 1px solid rgba(0,0,0,0.06); box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.04); }
  .card.success { border-top: 4px solid #10b981; }
  .card.rejected { border-top: 4px solid #ef4444; }
  .card.ok { border-top: 4px solid #0f766e; }
  h1 { color: #0f172a; margin: 0 0 0.5rem; font-size: 22px; }
  p { color: #64748b; font-size: 14px; }
  .btn { display: block; margin-top: 1.25rem; padding: 0.75rem; background: #1e293b; color: #fff; border-radius: 8px; text-decoration: none; font-weight: 600; font-size: 14px; }
  .btn:hover { background: #0f172a; }
  .btn.retry { background: #ef4444; }
  .btn.retry:hover { background: #dc2626; }
  .spinner { width: 32px; height: 32px; border: 3px solid #e2e8f0; border-top-color: #0f766e; border-radius: 50%; animation: spin 0.7s linear infinite; margin: 1rem auto 0; }
  @keyframes spin { to { transform: rotate(360deg); } }
</style>
